"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleStatements = void 0;
var types_1 = require("../types");
var comment_1 = require("./comment");
var switch_1 = require("./switch");
var forEach_1 = require("./forEach");
var return_1 = require("./return");
var break_1 = require("./break");
var throw_1 = require("./throw");
var try_1 = require("./try");
var setVariable_1 = require("./setVariable");
var functionCall_1 = require("./functionCall");
var handleStatements = function (statements, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _i, statements_1, statement, _a;
    var _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (context.$return !== undefined) {
                    // $return in a given function context stops all further statements execution
                    // note functions have their own scoped context so their caller won't see the $return
                    return [2 /*return*/];
                }
                _i = 0, statements_1 = statements;
                _c.label = 1;
            case 1:
                if (!(_i < statements_1.length)) return [3 /*break*/, 23];
                statement = statements_1[_i];
                _a = statement.$statement;
                switch (_a) {
                    case types_1.StatementType.Comment: return [3 /*break*/, 2];
                    case types_1.StatementType.Switch: return [3 /*break*/, 4];
                    case types_1.StatementType.ForEach: return [3 /*break*/, 6];
                    case types_1.StatementType.Return: return [3 /*break*/, 8];
                    case types_1.StatementType.Throw: return [3 /*break*/, 10];
                    case types_1.StatementType.Break: return [3 /*break*/, 12];
                    case types_1.StatementType.Try: return [3 /*break*/, 14];
                    case types_1.StatementType.SetVariable: return [3 /*break*/, 16];
                    case types_1.StatementType.FunctionCall: return [3 /*break*/, 18];
                }
                return [3 /*break*/, 20];
            case 2: return [4 /*yield*/, comment_1.handleCommentStatement(statement, context)];
            case 3:
                _c.sent();
                return [3 /*break*/, 21];
            case 4: return [4 /*yield*/, switch_1.handleSwitchStatement(statement, context)];
            case 5:
                _c.sent();
                return [3 /*break*/, 21];
            case 6: return [4 /*yield*/, forEach_1.handleForEachStatement(statement, context)];
            case 7:
                _c.sent();
                return [3 /*break*/, 21];
            case 8: return [4 /*yield*/, return_1.handleReturnStatement(statement, context)];
            case 9:
                _c.sent();
                return [3 /*break*/, 21];
            case 10: return [4 /*yield*/, throw_1.handleThrowStatement(statement, context)];
            case 11:
                _c.sent();
                return [3 /*break*/, 21];
            case 12: return [4 /*yield*/, break_1.handleBreakStatement(statement, context)];
            case 13:
                _c.sent();
                return [3 /*break*/, 21];
            case 14: return [4 /*yield*/, try_1.handleTryStatement(statement, context)];
            case 15:
                _c.sent();
                return [3 /*break*/, 21];
            case 16: return [4 /*yield*/, setVariable_1.handleSetVariableStatement(statement, context)];
            case 17:
                _c.sent();
                return [3 /*break*/, 21];
            case 18: return [4 /*yield*/, functionCall_1.handleFunctionCallStatement(statement, context)];
            case 19:
                _c.sent();
                return [3 /*break*/, 21];
            case 20: throw new Error("Unhandled statement type: " + ((_b = statement) === null || _b === void 0 ? void 0 : _b.$statement));
            case 21:
                if (context.$break || context.$return !== undefined) {
                    return [2 /*return*/];
                }
                _c.label = 22;
            case 22:
                _i++;
                return [3 /*break*/, 1];
            case 23: return [2 /*return*/];
        }
    });
}); };
exports.handleStatements = handleStatements;
//# sourceMappingURL=index.js.map